// --- START OF FILE src/pages/ContactUs.jsx ---

import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext'; 
import { useTranslation } from 'react-i18next'; 
import '../styles/Global.css'; 
import '../styles/ContactUs.css'; 

const ContactUs = () => {
  const { theme } = useTheme(); 
  const { t } = useTranslation(); 
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    console.log('Form data submitted:', formData);
    await new Promise(resolve => setTimeout(resolve, 1500)); 

    setSubmitMessage(t('contactUsFormSuccessMsg')); 
    setFormData({ name: '', email: '', message: '' });
    setIsSubmitting(false);
    
    setTimeout(() => setSubmitMessage(''), 5000);
  };

  const logoSrc = theme === 'dark' ? '/cloud-white.svg' : '/cloud-blue.svg';

  return (
    <div> 
      <h1 className="page-title">{t('contactUsPageTitle')}</h1>
      
      <div className="contact-page-container">
        <div className="contact-logo-column">
          <img 
            src={logoSrc} 
            alt={t('cloudSevenLogoAlt')} 
            // El comentario problemático ha sido eliminado o movido a una nueva línea:
            // {/* MODIFICACIÓN */}
            className="contact-logo-image"
          />
        </div>

        <div className="contact-separator"></div>

        <div className="contact-info-column">
          <div className="contact-details-section">
            <h2 className="contact-subtitle">{t('contactUsGetInTouchTitle')}</h2>
            <div className="contact-people-section">
              <div className="contact-person">
                <h3 className="contact-name">Johan Paul Pacheco Molina</h3>
                <p><a href="mailto:johan.pacheco@cloudseven.com.co" className="contact-email-link">johan.pacheco@cloudseven.com.co</a></p>
                <p className="contact-phone">{t('telLabel')} 319-583-1504</p>
              </div>
              <div className="contact-person">
                <h3 className="contact-name">Jofrey Edison Miranda Altamar</h3>
                <p><a href="mailto:jofrey.miranda@cloudseven.com.co" className="contact-email-link">jofrey.miranda@cloudseven.com.co</a></p>
                <p className="contact-phone">{t('telLabel')} 350-461-2354</p>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">{t('contactUsFullNameLabel')}</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                className="form-input" 
                placeholder={t('contactUsFullNamePlaceholder')}
                value={formData.name}
                onChange={handleChange}
                required 
                disabled={isSubmitting}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email" className="form-label">{t('contactUsEmailAddressLabel')}</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                className="form-input" 
                placeholder={t('contactUsEmailAddressPlaceholder')}
                value={formData.email}
                onChange={handleChange}
                required 
                disabled={isSubmitting}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message" className="form-label">{t('contactUsMessageLabel')}</label>
              <textarea 
                id="message" 
                name="message" 
                className="form-textarea" 
                placeholder={t('contactUsMessagePlaceholder')}
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              ></textarea>
            </div>
            <button 
              type="submit" 
              className="form-submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? t('contactUsSendingButton') : t('contactUsSendButton')}
            </button>
            {submitMessage && <p className="submit-message">{submitMessage}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
// --- END OF FILE src/pages/ContactUs.jsx ---